import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthTokenHandler } from '@app/modules/auth/services/auth-token-handler.service';
import { AuthSessionDeleter } from '@app/modules/auth/services/auth-user-session-deleter.service';
import { AuthTokenSignalHandler } from '@app/modules/auth/signal-handlers/auth-token-signal-handler';
import { AuthUserAuthenticatedSignalHandler } from '@app/modules/auth/signal-handlers/auth-user-authenticated-signal-handler';
import { UserResponseDTO } from '@app/modules/user/interfaces/user-response-dto.interface';

@Injectable()
export abstract class BaseGuard {
  protected router = inject(Router);
  protected userAuthenticationSignalHandler = inject(
    AuthUserAuthenticatedSignalHandler,
  );

  protected authTokenSignalHandler = inject(AuthTokenSignalHandler);
  protected tokenHandler = inject(AuthTokenHandler);
  protected sessionDeleter = inject(AuthSessionDeleter);

  protected abstract check(user: UserResponseDTO, isLogged: boolean): boolean;

  protected canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    return this.canActivateChild(route, state);
  }

  protected canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    return this.checkUserLogin(route, state);
  }

  protected checkUserLogin(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const userSignal =
      this.userAuthenticationSignalHandler.getUserAuthenticated();

    return this.check(userSignal(), !!userSignal()?.id);
  }
}
